import { InfoTip } from '@components/ui/InfoTip/InfoTip';
import { MockPill } from '@components/ui/MockPill/MockPill';
import type { SortDir } from '../useSortableRows';
import table from '../breakdownTable.module.css';

interface ISortableThProps<K extends string> {
  label: string;
  columnKey: K;
  sortKey: K;
  sortDir: SortDir;
  onSort: (key: K) => void;
  info?: string;
  mock?: boolean;
}

export function SortableTh<K extends string>({
  label,
  columnKey,
  sortKey,
  sortDir,
  onSort,
  info,
  mock = false,
}: ISortableThProps<K>) {
  const active = sortKey === columnKey;
  return (
    <th
      className={table.th}
      aria-sort={active ? (sortDir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <span className={table.thInner}>
        <button type="button" className={table.sortBtn} onClick={() => onSort(columnKey)}>
          {label}
          <span className={table.sortArrow} data-active={active}>
            {active ? (sortDir === 'asc' ? '▲' : '▼') : '↕'}
          </span>
        </button>
        {info && (
          <InfoTip text={info} className={table.infoTip} />
        )}
        {mock && <MockPill kind="badge" />}
      </span>
    </th>
  );
}